export default {
  title: 'Tu propio dominio',
  description:
    'Ejecuta las apps de tu equipo en un dominio propio en lugar de la dirección compartida. Conecta el dominio una vez: el panel, el portal de pedidos, el editor web y el estudio web obtienen cada uno una dirección en él.',
  read_only_description:
    'El dominio en el que este partner ejecuta sus apps. Solo el partner puede conectarlo o desconectarlo.',
  read_only_empty: 'Este partner no ha conectado ningún dominio.',
  not_connected: {
    label: 'Dominio',
    hint: 'El dominio que te pertenece, sin www — por ejemplo tumarca.com. Después añade en tu proveedor de dominio los registros DNS que te mostramos.',
    placeholder: 'tumarca.com',
    connect: 'Conectar',
  },
  apps: {
    dashboard: 'Panel',
    oms: 'Portal de pedidos',
    storefront: 'Editor web',
    website_studio: 'Estudio web',
  },
  status: {
    active: 'Activo',
    pending: 'Esperando DNS',
    failed: 'Requiere atención',
    disabled: 'Desconectado',
  },
  records: {
    title: 'Añade estos registros DNS para {{root}} en tu proveedor de dominio',
  },
  instructions: {
    title: 'Cómo añadir los registros',
    step_provider:
      'Inicia sesión donde se gestiona el DNS de {{root}}: normalmente la empresa donde compraste el dominio, o un servicio DNS como Cloudflare.',
    step_add:
      'Abre la configuración DNS de {{root}} y añade cada registro de abajo: elige el tipo y copia el nombre y el valor tal cual. Deja el TTL con su valor predeterminado.',
    step_check:
      'Guarda los registros y haz clic en «{{button}}». La mayoría de los proveedores publican los cambios en minutos; algunos tardan hasta 48 horas.',
    tip_name:
      'En el campo del nombre, la mayoría de los proveedores solo quieren la parte anterior a {{root}}, que aparece en negrita. Si el tuyo pide el nombre completo, copia el que aparece debajo.',
    tip_cloudflare:
      'En Cloudflare, pon los registros CNAME en «Solo DNS» (nube gris). Un registro con proxy oculta el CNAME, así que el dominio no se puede verificar.',
    tip_existing: 'No cambies los registros que ya tienes para {{root}} y www: tu sitio web sigue funcionando igual.',
  },
  summary: {
    live: 'Tu panel está activo en {{host}}.',
    pending:
      'Comprobamos tus registros DNS con regularidad. Los registros nuevos pueden tardar hasta 48 horas en encontrarse.',
    failed: 'Algunos registros no se pudieron verificar. Corrige los registros marcados abajo y vuelve a comprobar.',
    relogin:
      'Cuando {{host}} esté activo, tu equipo iniciará sesión allí. En la primera visita tendrán que volver a iniciar sesión.',
  },
  buttons: {
    check_again: 'Comprobar de nuevo',
    disconnect: 'Desconectar',
    retry: 'Intentar de nuevo',
  },
  disconnect_confirm: {
    title: '¿Desconectar {{root}}?',
    description: 'Tus apps vuelven a la dirección compartida y los enlaces en {{root}} dejan de funcionar.',
    ok: 'Desconectar',
  },
  toasts: {
    load_error: 'No se pudo cargar tu dominio.',
    load_error_read_only: 'No se pudo cargar el dominio de este partner.',
    connected: 'Dominio conectado. Añade los registros DNS de abajo.',
    connect_failed: 'No se pudo conectar el dominio.',
    check_started: 'Comprobando tus registros DNS.',
    check_failed: 'No se pudo iniciar la comprobación. Inténtalo de nuevo en un minuto.',
    disconnected: 'Dominio desconectado.',
    disconnect_failed: 'No se pudo desconectar el dominio.',
  },
};
